import { checkoutReducer } from './checkout.thunk';
import { manageSubscriptionReducer } from './manageSubscription.thunk';

export const subscriptionThunkReducers = {
  ...checkoutReducer,
  ...manageSubscriptionReducer,
};
